<template>
  <div>
    <button type="button" class="btn btn-primary btn-with-addon" @click="showModal">
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Book
    </button>

    <a-modal v-model="visible" title="Add new book">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Title">
          <a-input placeholder="Title"
            v-decorator="['title', { rules: [{ required: true, message: 'Please input book title!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
        </a-form-item>
        <a-form-item label="Author">
          <a-input placeholder="Author"
            v-decorator="['author', { rules: [{ required: true, message: 'Please input book author!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{ minRows: 2 }"
            v-decorator="['description', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
        </a-form-item>
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Book Code">
              <a-input placeholder="Book code. eg: CHEM-IX-UNIQUE"
                v-decorator="['code', { rules: [{ required: true, message: 'Please input book code!' }, { max: 30, message: 'Must not exceed 30 characters!' }] }]" />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Rack Name/Number">
              <a-input placeholder="Rack Name/Number"
                v-decorator="['rack_name', { rules: [{ required: false, message: 'Please input rack name!' }] }]" />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Select category">
              <a-select placeholder="Select category"
                v-decorator="['category_id', { rules: [{ required: true, message: 'Please select a category!' }] }]"
                @change="handleCategorySelect">
                <a-select-option v-for="(cat, index) in categories" :key="index"
                  :value="cat.id">{{ cat.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Select sub category">
              <a-select placeholder="Select sub category"
                v-decorator="['sub_category_id', { rules: [{ required: false, message: 'Please select a sub category!' }] }]">
                <a-select-option v-for="(cat, index) in subCategories" :key="index"
                  :value="cat.id">{{ cat.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <a-form-item label="No. of Copies">
              <a-input-number style="width: 100%" placeholder="No. of Copies"
                v-decorator="['total_quantity', { rules: [{ required: false, message: 'Please input book quantity!' }] }]" />
            </a-form-item>
          </div>

          <div class="col-md-6">
            <a-form-item label="Class">
              <a-select v-decorator="['class_id', { rules: [{ required: false, message: 'Please select a class!!' }] }]"
                placeholder="Select class">
                >

                <a-select-option v-for="(sclass, index) in schoolClasses" :value="sclass.id" :key="index">
                  {{ sclass.name }}
                </a-select-option>

              </a-select>
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Remark">
          <a-textarea placeholder="Remark" :autosize="{ minRows: 2 }"
            v-decorator="['remark', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

// import { fetchInventoryData } from '@/components/inventory/common'
/* const clearform = (form) => {
  // console.log('form', form)
  // console.log(form.fieldsStore)
  // console.log(Object.keys(form.fieldsStore.fields))
  try {
    let fieldnames = Object.keys(form.fieldsStore.fields)
    fieldnames.map((e, index) => {
      form.setFieldsValue({ [e]: undefined })
    })
  } catch (err) {
    console.error(err)
  }
} */
export default {
  name: 'NewBook',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      schoolClasses: [],
    }
  },
  mounted: function () {
    // let d = fetchInventoryData('category')
    this.getParentCategories()
    // d.then(data => { this.categories = data.data }).catch(err => console.error(err))
  },
  watch: {
    formVisible: function (n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
      this.getClasses()
    },
    getParentCategories: function () {
      this.$http.get('/api/library/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function (selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_id === selectedCategoryId)
    },
    handleCategorySelect: function (selectedCategoryId) {
      console.log('selectedCategoryId:: ', selectedCategoryId)
      this.getSubCategories(selectedCategoryId)
    },
    getClasses: function () {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    savedata: function () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to add ${values.title}?`,
            content: `Click on the OK button to add the new Book!`,
            onOk: () => {
              this.$http.post('/api/library/books', {
                title: values.title,
                author: values.author,
                description: values.description,
                category_id: values.category_id,
                sub_category_id: values.sub_category_id,
                class_id: values.class_id ? values.class_id : null,
                rack_name: values.rack_name,
                remark: values.remark,
                status: 1,
                code: values.code,
                total_quantity: values.total_quantity,
                balance_quantity: values.total_quantity,
              })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200 || resp.status === 201) {
                    this.$notification['success']({
                      message: resp.data.message.success,
                      description: `${values.title} added successfully!`,
                    })
                    console.log('response: ', resp)
                    // this.showInwardTransactionModal(resp.data.data)
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
    showInwardTransactionModal(record) {
      this.$eventBus.$emit('showInwardTransactionForm', record)
    },
  },
}
</script>

<style></style>
